<script>
    import marked from 'marked'
    import { SyncLoader } from "svelte-loading-spinners";
    import { onMount } from "svelte";
    import { getFund } from "../api/fund.js";
    import { toasts } from "../stores.js";
    import { replace } from "svelte-spa-router";

    export let params

    let oldTitle;
    let oldDescription;
    let textArea;

    $: title = "";
    $: description = "";
    $: email = "";
    $: password = "";

    function setSelectionRange(input, selectionStart, selectionEnd) {
        input.focus();
        if (input) {
            console.log(input.selectionStart, input.selectionEnd)
            input.selectionStart = 0
            input.selectionEnd = 10
            console.log(input.selectionStart, input.selectionEnd)
        }
        console.log(input.selectionStart, input.selectionEnd)
        console.log(input.selectionStart, input.selectionEnd)
    }
    $: {
        if (textArea) console.log(textArea.selectionStart, textArea.selectionEnd)
    }

    const addLine = (line, selectionStart, selectionEnd) => {
        description = description + line;
        setSelectionRange(textArea, 1, 5);
    }

    const onSubmit = () => {
        creating = true
        let data = {}
        if (title != oldTitle) {
            data.title = title
        }
        if (description != oldDescription) {
            data.description = description
        }

        fetch(
            "http://172.81.181.23:3004/editFund?fund_id=" + params.fundId,
            {
                method: "POST",
                headers: {
                    Email: email,
                    Passkey: password,
                    Authorization: "Basic womp"
                },
                body: JSON.stringify(data)
            }
        )
        .then(async res => {
            let json = await res.json()
            if (res.status != 200) {
                if (json.detail == "Invalid credentials") {
                    toasts.pushToast("invalid credentials", "error")
                }
                else {
                    toasts.pushToast("error updating fund", "error")
                }
            }
            else {
                toasts.pushToast("update successful", "success")
                replace("/fund/" + params.fundId);
            }
        })
        creating = false
    }

    $: {
        if (description.length > 1000) {
            description = description.substring(0,1000);
        }
    }

    $: creating = false
    onMount(async() => {
        let fund = await getFund(params.fundId);
        oldDescription = fund.description;
        oldTitle = fund.title;
        description = oldDescription;
        title = oldTitle;
    })
</script>

<div class="main">
    <h1 style="margin-bottom: 0px;">Edit Your Fundraiser</h1>
    <div class="ui divider divy" style="margin-top: 0.4rem;"></div>
    <div class="input-row">
        <h4 style="margin: 0px; align-self: center; margin-right: 1rem;">Title</h4>
        <input bind:value={title} class="title"/>
    </div>
    <div class="input-row description" style="margin-top: 1rem;">
        <h4 style="margin: 0px; margin-right: 1rem;">Description</h4>
        <div style="flex-grow: 1;">
            <div style="width: 100%;">
                <div class="ui small basic icon buttons">
                    <button on:click={() => addLine("\n\n# Header 1", 0, 15)} class="ui button" data-bcup-haslogintext="no">H1</button>
                    <button on:click={() => addLine("\n\n## Header 2", 0, 15)} class="ui button" data-bcup-haslogintext="no">H2</button>
                    <button on:click={() => addLine("\n\n### Header 3", 0, 15)} class="ui button" data-bcup-haslogintext="no">H3</button>
                    <button on:click={() => addLine("\n\n#### Header 4", 0, 15)} class="ui button" data-bcup-haslogintext="no">H4</button>
                    <button on:click={() => addLine("\n\n- Bullet Point 1", 0, 15)} class="ui button" data-bcup-haslogintext="no"><i class="egg ui icon minus"/></button>
                </div>
            </div>
            <textarea bind:this={textArea} style="margin-top: 1rem; font-size: 14px;" class="markdown" bind:value={description}/>
            <h3 style="margin-bottom: 0px;">Preview</h3>
            <div class="ui divider divy" style="margin-top: 0.4rem;"></div>
            <div class="preview">{@html marked(description)}</div>
        </div>
    </div>
    <h3 style="margin-bottom: 0px;">Credentials to Verify Changes</h3>
    <div class="ui divider divy" style="margin-top: 0.4rem;"></div>
    <div class="input-row" style="margin-bottom: 1rem;">
        <h4 style="margin: 0px; align-self: center; margin-right: 1rem;">Email</h4>
        <input bind:value={email} class="title"/>
    </div>
    <div class="input-row">
        <h4 style="margin: 0px; align-self: center; margin-right: 1rem;">Password</h4>
        <input bind:value={password} class="title" type="password"/>
    </div>
    <div class="finish">
            {#if creating}
                <div class="loader">
                    <SyncLoader color="#17C3B2" duration="1s" size="2" unit="rem"/>
                </div>
            {:else}
                <button 
                    on:click={onSubmit}
                    class="fc b dim br2 ph3 pv2 mb2 dib white bg-brand-green"
                >
                    Submit Changes
                </button>
            {/if}
    </div>
</div>

<style>
    .input-row {
        display: flex;
        flex-direction: row;
        height: fit-content;
        align-items: start;
        justify-content: space-between;
    }
    .loader {
        margin-top: 0.3rem;
    }
    .finish {
        padding-top: 1rem;
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .green-button {
        background-color: #17C3B2 !important;
    }
    .ed {
        padding-right: 2px;
        padding-bottom: 5px;
        padding-top: 2px;
        height: fit-content;
        width: fit-content;
    }
    .title {
        width: auto;
        flex-grow: 1;
        font-size: 14px;
        padding-top: 2px;
        padding-bottom: 2px;
    }
    .markdown {
        width: 100%;
        resize: vertical;
        height: 20rem;
    }
    .main {
        width: 100%;
        margin-bottom: 2rem;
    }
    input {
        padding-top: 10px;
        padding-bottom: 10px;
        overflow: visible;
    }
    .egg {
        z-index: 0;
    }
    .description {
        display: block;
    }
    
    @media only screen and (min-width: 768px) {
        .description {
            display: flex;
        }
        .main {
            width: 100%rem;
            min-width: 30%;
            max-width: 90%;
        }
    }
</style>
